
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class OrderProductsDialog extends Serenity.EntityDialog<OrderProductsRow, any> {
        protected getFormKey() { return OrderProductsForm.formKey; }
        protected getIdProperty() { return OrderProductsRow.idProperty; }
        protected getLocalTextPrefix() { return OrderProductsRow.localTextPrefix; }
        protected getNameProperty() { return OrderProductsRow.nameProperty; }
        protected getService() { return OrderProductsService.baseUrl; }
        protected getDeletePermission() { return OrderProductsRow.deletePermission; }
        protected getInsertPermission() { return OrderProductsRow.insertPermission; }
        protected getUpdatePermission() { return OrderProductsRow.updatePermission; }

        protected form = new OrderProductsForm(this.idPrefix);

    }
}